import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "44",
  height: "44",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FBFBFD",
  d: "M16.707 22.707a1 1 0 0 1 0-1.414l4.95-4.95a1 1 0 0 1 1.414 0l4.95 4.95a1 1 0 0 1 0 1.414l-4.95 4.95a1 1 0 0 1-1.414 0z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  "fill-rule": "evenodd",
  d: "M8 22c0 7.732 6.268 14 14 14v3c-9.389 0-17-7.611-17-17S12.611 5 22 5s17 7.611 17 17h-3c0-7.732-6.268-14-14-14S8 14.268 8 22m11.394 0 2.97 2.97 2.97-2.97-2.97-2.97zm-2.687-.707a1 1 0 0 0 0 1.414l4.95 4.95a1 1 0 0 0 1.414 0l4.95-4.95a1 1 0 0 0 0-1.414l-4.95-4.95a1 1 0 0 0-1.414 0zm15.737 4.577c-.276 0-.5.212-.5.475v9.484l-3.097-3.098a.5.5 0 0 0-.708 0l-1.2 1.2a.5.5 0 0 0 0 .707l6 6a.5.5 0 0 0 .708 0l1.2-1.2.015-.016 4.784-4.784a.5.5 0 0 0 0-.708l-1.2-1.2a.5.5 0 0 0-.707 0l-3.098 3.098v-9.483a.49.49 0 0 0-.5-.475z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }